import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cN from 'classnames';
import dayjs from 'dayjs';
import { I_PopularInfo } from '@Redux/search/interfaces';
import { RootState } from '@Redux/search/store';
import { setPopularinfo } from '@Redux/search/actions';
import Card from './subComponent/Card';
import styles from './styles.module.scss';
import { useMediaQuery } from 'react-responsive';
import domainByEnv from '@utils/domainByEnv';

const Recommends: React.FC = () => {
    const moduleName = 'recommends';
    const {
        PopularInfo,
        SwitchListBy,
        GroupListInfo,
        GroupListInfoM,
        SingleGroupListInfo,
        SingleGroupListInfoM,
    } = useSelector((state: RootState) => state.search);

    // 按鈕功能為"切換各團顯示(列表)"時，顯示結果為卡片
    const isCards = SwitchListBy === 'List';
    const isPC = useMediaQuery({ query: '(min-width: 980px)' });

    let isShow = false;

    if (isCards) {
        isPC && GroupListInfo.data?.NormGroupList.length === 0 && (isShow = true);
        !isPC && GroupListInfoM.data?.NormGroupList.length === 0 && (isShow = true);
    } else {
        isPC && SingleGroupListInfo.data?.SingleGroupList.length === 0 && (isShow = true);
        !isPC && SingleGroupListInfoM.data?.SingleGroupList.length === 0 && (isShow = true);
    }

    const dispatch = useDispatch();

    useEffect(() => {
        const reqBody = {
            ShowCount: 3,
            Type: '2',
            Country: 'TW',
            ArriveID: '--9',
            GoDateStart: dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
            GoDateEnd: dayjs().add(90, 'days').format('YYYY-MM-DD'),
        };

        dispatch(setPopularinfo(reqBody));
    }, [dispatch]);

    const onErrImg = (() => {
        if (process.env.ENV === 'prod') {
            return 'https://www.liontravel.com/cto/view/default16-9.jpg';
        }

        if (process.env.ENV === 'rel') {
            return 'https://uwww.liontravel.com/cto/view/default16-9.jpg';
        }

        return '/uliontravel/cto/view/default16-9.jpg';
    })();

    return isShow ? (
        <div className={cN(moduleName, styles[`${moduleName}`])}>
            <div className={styles.Title}>精選人氣推薦</div>
            <div className={styles.Cards}>
                {PopularInfo?.map((item: I_PopularInfo, i: number) => {
                    const productParams = new URLSearchParams();

                    productParams.append('NormGroupID', item.NormGroupID);
                    productParams.append('GroupID', item.GroupList[0]?.GroupID);

                    const productLink = `${domainByEnv(false)}/detail?${productParams.toString()}`;

                    const cardProps = {
                        imgSrcPC: item.Img,
                        imgSrcM: item.ImgM,
                        onErrImg,
                        imgAlt: item.TourName,
                        imgTitle: item.TourName,
                        productInfo: item.TourName,
                        productLink: productLink,
                        price: item.GroupStraightPrice,
                    };
                    return <Card key={i} {...cardProps} />;
                })}
            </div>
        </div>
    ) : null;
};

export default Recommends;
